import React from "react";
import maintenanceImage from "../91533050_2894.svg"

const MaintenancePage = () => {


  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-500 to-blue-300">
      <div className="text-center bg-white  p-10 shadow-2xl rounded-2xl max-w-lg w-full">
        <div className="flex flex-col items-center space-y-6">


        <img
          src={maintenanceImage} 
          alt="Maintenance Image"
          className="h-40 w-50 rounded-lg"
        />
          
        {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-16 w-16 text-blue-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
             <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13 16h-1v-4h-.01M13 8h-1m6.938 4.292a9 9 0 11-11.856 0M12 2v2m0 16v2m7.071-7.071l1.414 1.414m-14.142 0l1.414-1.414M18.364 5.636l1.414-1.414m-14.142 0l1.414 1.414"
            />
          </svg> */}
  
          
          <h1 className="text-3xl font-bold text-red-500">
            Site Under Maintenance
          </h1>
  
          
          <p className="text-gray-600 leading-relaxed">
            We’re currently making some exciting updates to improve your experience. 
            Please bear with us. We’ll be back online soon!
          </p>
  
          
          <div className="w-full bg-gray-200 rounded-full h-2.5">
            <div
              className="bg-blue-500 h-2.5 rounded-full"
              style={{ width: '70%' }}
            ></div>
          </div>
  
        </div>
      </div>
    </div>
  );
  
  



};

export default MaintenancePage;
